export default __webpack_public_path__ + "static/media/okara-logo-header_2.541f005f.png";